import { Link } from "react-router-dom";
import { Home, ArrowRight } from "lucide-react";
import { Seo } from "@/components/Seo";
import { container, btnPrimary } from "@/lib/ui";

export default function NotFound() {
  return (
    <>
      <Seo title="Page Not Found" description="The page you're looking for doesn't exist." path="/404" />
      <section className="min-h-[70vh] grid place-items-center bg-neutralbg">
        <div className={`${container} text-center`}>
          <span className="font-heading text-7xl font-extrabold text-navy">404</span>
          <h1 className="mt-4 font-heading text-2xl font-bold text-navy">This page couldn't be found</h1>
          <p className="mt-3 text-gray-600 max-w-md mx-auto">
            The page may have moved. Let's get you back to a cleaner path.
          </p>
          <Link to="/" className={`${btnPrimary} mt-8`}>
            <Home className="w-4 h-4" /> Back to home <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </section>
    </>
  );
}
